import React, {FC, useCallback, useMemo} from 'react';
import styled from '@emotion/styled'
import Modal from '@material-ui/core/Modal';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import {MusicPaper} from '@consts/types';
import {encode as encodeSqueezeBase64} from "@utils/squeezeBase64";
// import copyToClipboard from "@utils/copy-to-clipboard";
import saveFile from "@utils/saveFile";

type UploadModalProps = {
  isOpen: boolean;
  musicPaper: MusicPaper
  closeDownloadModal: VoidFunction;
}

const ModalContainer = styled.div`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  width: 500px;
  height: auto;
  background-color: #fff;
  padding: 15px;
  outline: none;
`;

export const CustomButton = styled(Button)`
  &.MuiButton-root {
    background: #fff;
    color: #2f2f2f;
    border: 1px solid #2f2f2f;
    box-shadow: none;
    &:hover {
      background: #fff;
      box-shadow: none;
    }
  }
`;

export const ExportModal: FC<UploadModalProps> = ({
  isOpen,
  musicPaper,
  closeDownloadModal
}) => {
  const dataString = useMemo(() => encodeSqueezeBase64(musicPaper), [musicPaper])
  const handleDownload = useCallback(() => {
    const file = new Blob([dataString], { type: 'application/json' });
    saveFile(file, `${musicPaper.title}.json`)
  }, [dataString, musicPaper])

  // const handleCopyToClipboard = useCallback(() => {
  //   copyToClipboard(dataString);
  // }, [dataString])

  return (
    <Modal open={isOpen} onClose={closeDownloadModal} >
      <ModalContainer>
        <Box sx={{ mb: 2 }} >
          <TextField
            label="Copy data to the clipboard or export as a file"
            multiline
            rows={16}
            value={dataString}
            fullWidth
          />
        </Box>
        {/*<Box sx={{ mb: 2 }} >*/}
        {/*  <Button*/}
        {/*    variant="contained"*/}
        {/*    fullWidth*/}
        {/*    disabled={dataString.length <= 0}*/}
        {/*    onClick={handleCopyToClipboard}*/}
        {/*  >*/}
        {/*    Export to clipboard*/}
        {/*  </Button>*/}
        {/*</Box>*/}
        <CustomButton
          variant="contained"
          fullWidth
          disabled={dataString.length <= 0}
          onClick={handleDownload}
        >
          Export
        </CustomButton>
      </ModalContainer>
    </Modal>
  )
}
